import Card from 'react-bootstrap/Card';
import React, { useEffect, useState } from 'react';
import { Accordion, Button } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import _ from 'lodash';
import { PREVIOUSLY_USER_SEARCH_LOCAL_STORAGE_KEY } from '../utils';
import { PreviouslySearchedType } from '../typedefs';

const PreviouslySearchedUsers = (
  {
    handleSearchUrl,
    handleInputChange,
    loadExpanded = false,
    reRender,
    onCollapse,
  }: {
    handleSearchUrl: (userid: string) => Promise<void>,
    handleInputChange: (event: { target: { value: string } }) => void,
    loadExpanded?: boolean,
    reRender?: unknown,
    onCollapse?: () => void,
  }
) => {
  const [expanded, setExpanded] = useState(loadExpanded ?? false);
  const [previouslySearches, setPreviouslySearches] = useState<PreviouslySearchedType[]>([]);

  const loadPreviouslySearched = () => {
    const cache = localStorage.getItem(PREVIOUSLY_USER_SEARCH_LOCAL_STORAGE_KEY);
    if (!cache) {
      setPreviouslySearches([]);
      return;
    }

    const cacheData = JSON.parse(cache) as PreviouslySearchedType[];
    setPreviouslySearches(cacheData ?? []);
  };

  const deletePreviouslySearched = () => {
    localStorage.removeItem(PREVIOUSLY_USER_SEARCH_LOCAL_STORAGE_KEY);
    loadPreviouslySearched();
  };

const toggleExpanded = () => {
  if (!expanded) {
    loadPreviouslySearched();
    setExpanded(true);
  } else if (onCollapse) {
    onCollapse();
  } else {
    setExpanded(false);
  }
};
  useEffect(() => {
    if (loadExpanded || !_.isNil(reRender)) {
      loadPreviouslySearched();
      if (loadExpanded) {
        setExpanded(true);
      }
    }
  }, [loadExpanded, reRender]);

  const handlePreviousSearch = (userId: string) => {
    handleInputChange({ target: { value: userId } });
    handleSearchUrl(userId);
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <Accordion activeKey={expanded ? '0' : ''}>
          <Accordion.Toggle
            as={Card.Title}
            variant="link"
            eventKey="0"
            onClick={toggleExpanded}
          >
            <div
              style={{
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              Previously Searched Users
              <Button variant="link" className="p-0">
                {!expanded && <i className="fas fa-chevron-down" />}
                {expanded && <i className="fas fa-chevron-up" />}
              </Button>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <div>
              <div className="d-flex float-right mb-2">
                <Button
                  className="mr-2"
                  size="sm"
                  onClick={loadPreviouslySearched}
                >
                  Reload
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={deletePreviouslySearched}
                >
                  Clear cache
                </Button>
              </div>

              <Table striped bordered size="sm" id="cachedSearchTable">
                <thead>
                  <tr>
                    <th>User ID</th>
                    <th>User Name</th>
                    <th>Search</th>
                  </tr>
                </thead>
                <tbody>
                  {previouslySearches?.map((previousSearch) => (
                    <tr key={previousSearch.userId}>
                      <td>{previousSearch.userId}</td>
                      <td>{previousSearch.username}</td>
                      <td>
                        <Button
                          onClick={() => handlePreviousSearch(previousSearch.userId)}
                        >
                          Search
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Accordion.Collapse>
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default PreviouslySearchedUsers;
